<app-page-header pageTitle="Perfil" />

<div class="rounded-2xl border border-gray-200 bg-white p-5 dark:border-gray-800 dark:bg-white/[0.03] lg:p-6">
  @if (loading) {
    <app-spinner />
  } @else {
    <div>
      <div class="flex flex-col items-center w-full">
        <app-avatar-user [userName]="user.name || ''" />
        @if (user) {
          <h3 class="font-semibold text-gray-800 text-theme-xl dark:text-white/90">{{ user.name }}</h3>
          <h4 class="text-theme-sm text-gray-600 dark:text-white/90">{{ user.email }}</h4>
        }
      </div>

      <mat-tab-group mat-stretch-tabs="false" mat-align-tabs="start" animationDuration="0ms">
        <mat-tab>
          <ng-template mat-tab-label>
            <span class="dark:text-white/90">Configuración</span>
          </ng-template>
          <ng-template matTabContent>
            <app-cambiar-contrasenha />
          </ng-template>
        </mat-tab>
      </mat-tab-group>
    </div>
  }
</div>
